export var HttpApiKeyAuthLocation = /*#__PURE__*/function (HttpApiKeyAuthLocation) {
  HttpApiKeyAuthLocation["HEADER"] = "header";
  HttpApiKeyAuthLocation["QUERY"] = "query";
  return HttpApiKeyAuthLocation;
}(HttpApiKeyAuthLocation || {});